module.exports = __webpack_public_path__ + "media/images/back-to-home-1304c7b47f362053ac274f965dd37900.svg";